import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoginModel } from '../../models/account.model';
import { AccountService } from '../../services/account.service';
import { DynamicForm } from '../../models/dynamic.model';
import { BaseComponent } from '../../models/base/base.component';
import { NavigationService } from '../../services/navigation.service';
import { IpAddressService } from '../../services/ip-address.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  form: DynamicForm = new DynamicForm();
  private destroy$ = new Subject<void>();

  redirectUrl: string;

  constructor(
    private accountService: AccountService,
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    private ipAddressService: IpAddressService) {
    super();

    this.form.title = 'Login';
    this.form.key = 'loginForm';
    this.form.submitLabel = 'Sign On';
    this.form.autocomplete = true;

    this.form.addRow();

    this.form.addControl('username', 'text', 'User Name', null, true, null, 12);
    this.form.addControl('password', 'password', 'Password', null, true, null, 12);
  }

  ngOnInit() {
    // Check if user is already logged in and redirect to orders dashboard
    this.accountService.isLoggedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.navigationService.showTopNav(true);
          this.router.navigate(['/orders']);
          return;
        }
      });

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params['redirectUri'] != null) {
          this.redirectUrl = params['redirectUri'];
        }
      });
    this.navigationService.showTopNav(false);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login(form: any) {
    this.isLoading = true;
    
    // Try to get IP address with a short timeout, then proceed with login regardless
    this.ipAddressService.getIpAddress().subscribe({
      next: (ipAddress: string) => {
        console.log('Retrieved IP address:', ipAddress);
        this.performLogin(form, ipAddress);
      },
      error: (error) => {
        console.warn('Could not retrieve IP address, proceeding without it:', error);
        this.performLogin(form, 'Not available');
      }
    });
  }

  private performLogin(form: any, ipAddress: string) {
    let model = new LoginModel();
    model.Username = form.value.username;
    model.Password = form.value.password;
    model.RedirectUri = this.redirectUrl;
    model.IpAddress = ipAddress;

    this.accountService
      .login(model)
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.navigationService.showTopNav(true);
          if (
            res != null &&
            res.body != null &&
            res.body.redirectUri != null &&
            res.body.redirectUri.length > 0 &&
            res.body.twoFactorVerified
          ) {
            this.router.navigate([res.body.redirectUri]);
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Login failed:', error);
        }
      });
  }

  clickButton(key: string) {
    if (key === 'reset') {
      this.redirectTo('/resetPassword');

    }
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

}
